import { Box, Typography } from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const Confirmation = () => {
  const navigate = useNavigate();

  return (
    <Box width="80%" margin="100px auto" textAlign="center">
      <CheckCircleOutlineIcon sx={{ fontSize: 90, color: "#1fc77a", mb: 2 }} />
      <Typography variant="h3" fontWeight="bold" marginBottom="20px">
        Thank You For Your Order!
      </Typography>
      <Typography variant="h6" marginBottom="30px">
        Your order has been successfully placed and is being processed.
      </Typography>
      <Typography variant="body1" marginBottom="40px">
        You will receive an email confirmation with your order details shortly.
      </Typography>
      <CustomButton
        variant="contained"
        size="large"
        onClick={() => navigate("/")}
      >
        Continue Shopping
      </CustomButton>
    </Box>
  );
};

export default Confirmation;
